import React from 'react';
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiFlag } from "react-icons/fi";
import { BsFillXCircleFill, BsCheckCircleFill } from "react-icons/bs";
import "./DoubleMaterialityUpsale.scss";
import Double_materiality from '../images/Double_materiality.png';
import Double_materiality_matrix from '../images/Double_materiality_matrix.png';

const DoubleMaterialityUpsale = ({ t }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/company_admin/home");
  };

  const handleContactUpgrade = () => {
    // Handle contact upgrade action
    console.log("Contact upgrade clicked");
  };

  return (
    <div className="double-materiality-upsale" data-testid="double-materiality-upsale">
      {/* Top Section - Light gray background with two columns */}
      <section className="top-section" data-testid="top-section">
        <div className="container">
          <div className="row align-items-center m-0">
            {/* Left Column - Content */}
            <div className="col-lg-5" data-testid="top-left-column">
              <h1 className="main-heading" data-testid="main-heading">
                {t("DoubleMaterialityUpsale.mainHeading.label")}
              </h1>
              <p className="main-description" data-testid="main-description">
                {t("DoubleMaterialityUpsale.mainDescription.label")}
              </p>
              <div className="mb-4">
                <b> {t("DoubleMaterialityUpsale.upgradeNotice.label")}</b>
              </div>
              <div className="button-group" data-testid="button-group">
                <button
                  className="btn btn-primary upgrade-btn"
                  onClick={handleContactUpgrade}
                  data-testid="upgrade-btn"
                >
                  {t("DoubleMaterialityUpsale.contactUpgrade.label")}
                </button>
                <button
                  className="btn btn-outline-secondary home-btn"
                  onClick={handleBackToHome}
                  data-testid="upgrade-btn"
                >
                  {t("DoubleMaterialityUpsale.goToHome.label")}
                </button>

              </div>
            </div>

            {/* Right Column - Image */}
            <div className="col-lg-7" data-testid="top-right-column">
              <div className="dashboard-image-container" data-testid="dashboard-image-container">
                <img
                  src={Double_materiality}
                  alt="Dashboard Screenshot"
                  className="dashboard-image"
                  data-testid="dashboard-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Middle Section - Two columns */}
      <section className="middle-section" data-testid="middle-section">
        <div className="container">
          <div className="row align-items-center m-0">
            {/* Left Column - Image */}
            <div className="col-lg-6" data-testid="middle-left-column">
              <div className="matrix-image-container" data-testid="matrix-image-container">
                <img
                  src={Double_materiality_matrix}
                  alt="Materiality Matrix"
                  className="matrix-image"
                  data-testid="matrix-image"
                />
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="col-lg-6" data-testid="middle-right-column">
              <h2 className="section-title" data-testid="section-title">
                {t("DoubleMaterialityUpsale.sectionTitle.label")}
              </h2>
              <ul className="feature-list" data-testid="feature-list">
                <li className="feature-item" data-testid="feature-item-1">
                  <FiFlag className="check-icon" />
                  <span>{t("DoubleMaterialityUpsale.bulletPoint1.label")}</span>
                </li>
                <li className="feature-item" data-testid="feature-item-2">
                  <FiFlag className="check-icon" />
                  <span>{t("DoubleMaterialityUpsale.bulletPoint2.label")}</span>
                </li>
                <li className="feature-item" data-testid="feature-item-3">
                  <FiFlag className="check-icon" />
                  <span>{t("DoubleMaterialityUpsale.bulletPoint3.label")}</span>
                </li>
                <li className="feature-item" data-testid="feature-item-4">
                  <FiFlag className="check-icon" />
                  <span>{t("DoubleMaterialityUpsale.bulletPoint4.label")}</span>
                </li>
                <li className="feature-item" data-testid="feature-item-5">
                  <FiFlag className="check-icon" />
                  <span>{t("DoubleMaterialityUpsale.bulletPoint5.label")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Section - Comparison Table */}
      <section className="bottom-section" data-testid="bottom-section">
        <div className="container px-4">
          <div className='mb-3'>
            <h4 className="step-up-title fw-bold" data-testid="step-up-title">
              Step Up Your Plan
            </h4>
          </div>
          <div className='row m-0 OurPlansSection'>
            <div className='col-md-6 p-2'>
              <div className='OurPlansSection_List'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>{t("OurPlans.label")}</h6>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("DoubleMaterialityUpsale.table.materialityType.label")}</h6>
                    <p>{t("DoubleMaterialityUpsale.table.materialityType.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("DoubleMaterialityUpsale.table.stakeholdersurveys.label")}</h6>
                    <p>{t("DoubleMaterialityUpsale.table.stakeholdersurveys.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("DoubleMaterialityUpsale.table.materialissuelibrary.label")}</h6>
                    <p>{t("DoubleMaterialityUpsale.table.materialissuelibrary.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("DoubleMaterialityUpsale.table.peerbenchmarking.label")}</h6>
                    <p>{t("DoubleMaterialityUpsale.table.peerbenchmarking.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("DoubleMaterialityUpsale.table.heatmapanalytics.label")}</h6>
                    <p>{t("DoubleMaterialityUpsale.table.heatmapanalytics.plan.label")}</p>
                  </li>
                  
                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.currentPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  
                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.upgradedPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                 

                </ul>
              </div>
            </div>
          </div>
          <div className="button-group text-right p-2" data-testid="button-group">
            <a
              href="mailto:info@ecodrisil.com"
              className="btn btn-primary upgrade-btn"
            >
              {t("GolasKpisUpsale.topSection.upgradeButton.label")}
            </a>
          </div>
       
        </div>
      </section>
    </div>
  );
};

export default withTranslation()(DoubleMaterialityUpsale);
